import {
  SET_DIALOG,
  SET_DIALOG_CONTENT_PROP,
  SET_DIALOG_PROP,
} from '../constants/ActionTypes';

const initialState = {
  name: '',
  open: false,
  hideClose: false,
  contentProps: {},
  dialogProps: {},
  actions: [],
  queue: [],
};

const toDialog = (action) => ({
  name: action.name,
  open: action.open,
  hideClose: action.hideClose,
  dialogProps: action.dialogProps,
  contentProps: action.contentProps,
  actions: action.actions,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DIALOG: {
      // Only one dialog can be on screen at a time. If something is already
      // open under a different name, queue this request instead of
      // clobbering it - it opens once the current dialog closes.
      if (action.open && state.open && state.name !== action.name) {
        return { ...state, queue: [...state.queue, toDialog(action)] };
      }

      // Closing (or nothing was open): promote the next queued dialog, if
      // any, instead of dropping straight to the empty/closed defaults.
      if (!action.open && state.queue.length) {
        const [next, ...rest] = state.queue;
        return { ...state, ...next, queue: rest };
      }

      return { ...state, ...toDialog(action) };
    }
    case SET_DIALOG_CONTENT_PROP:
      return {
        ...state,
        contentProps: {
          ...state.contentProps,
          [action.key]: action.value,
        },
      };
    case SET_DIALOG_PROP:
      return {
        ...state,
        dialogProps: {
          ...state.dialogProps,
          [action.key]: action.value,
        },
      };
    default:
      return state;
  }
};
